import { useMutation } from '@apollo/client';
import { CANCEL_CHARGING_SESSION } from '@mutations/cancelChargingSession';
import { showToast } from 'components/common/CustomToast';
import { useParkingStore } from 'stores/parkingStore';
import {
  Mutation,
  MutationCancelChargingSessionArgs,
} from 'types/generatedSchemaTypes';
import { useUiStore } from 'stores/uiStore';

const useCancelChargingMutation = () => {
  const [cancelChargingSession, { loading }] = useMutation<
    Mutation,
    MutationCancelChargingSessionArgs
  >(CANCEL_CHARGING_SESSION, {
    onCompleted: async () => {
      showToast('evCharging.chargingCancelSuccess', 'success');
      useUiStore.getState().setSheetModal('');
      useParkingStore.getState().setSelectedOngoingSession(undefined);
    },
    onError: () => {
      useUiStore.getState().setSheetModal('');
      showToast('error.chargingCancel', 'error');
    },
  });

  return { cancelChargingSession, loading };
};

export default useCancelChargingMutation;
